import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axios from "@utils/axios";

export interface RemoteStopParams {
  evseID: string;
  sessionID: string;
}

export interface RemoteStopResponse {
  status: string;
  message: string;
}

const remoteStop = async (params: RemoteStopParams): Promise<RemoteStopResponse> => {
  const response = await axios.get(`/api/evse/${params.evseID}/end-session/${params.sessionID}/`);
  return response.data as RemoteStopResponse;
};

export const useRemoteStop = (options?: Omit<UseMutationOptions<RemoteStopResponse, Error, RemoteStopParams>, "mutationFn">) => {
  return useMutation({
    mutationFn: remoteStop,
    ...options
  });
};
